import React from 'react';
import { AdUnit } from '@/tracking/ads/components/AdUnit';
import { GPTAds } from '@/tracking/ads/GPTAds';
import { AdPositions } from '@/tracking/ads/types';

// Big-screen / takeover slot. Full-bleed black band on the page so the
// creative sits in a letterboxed frame, with the pillarbox filling any
// viewport width the creative itself doesn't cover. Deliberately uncapped:
// takeover creatives are trafficked wider than the content grid, and a
// max-width here would crop them (the ad div sets `overflow-hidden`)
// rather than scale them down.
export const FullscreenAd = () => (
  // `isolate` traps the GPT creative's z-index inside this wrapper's own
  // stacking context. The ad iframe can set a sky-high z-index, but isolation
  // keeps it from painting over sibling content (e.g. the home hero search box).
  <div className="isolate w-full bg-black">
    <AdUnit generator={GPTAds[AdPositions.Fullscreen]} />
  </div>
);
